import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

export class FeatureFlags {
  [key: string]: boolean;
}

export interface IFeatureFlagsService {
  loadFeatureFlags(): Observable<FeatureFlags>;
}

export const FEATURE_FLAGS_SERVICE = new InjectionToken<IFeatureFlagsService>('Feature flags service');

/** The flag that gates access to the feature flags admin page. */
export const FEATURE_FLAG_SHOW_ADMIN = 'FeatureFlags_ShowAdmin';

export interface FeatureFlagsRoutingGuardConfig {
  flagName: string;
  redirectTo: string;
}
